import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import type { AnalyticEventData } from '@gonfalon/analytics/types';

const trackViewEvent = createTrackerForCategory('Views');

/****************************************
 * View creation
 ****************************************/

export function trackCreateViewButtonClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Create View Button Clicked', attributes);
}

export function trackCreateViewAndCloseButtonClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Create View And Close Button Clicked', attributes);
}

export function trackCreateViewAndLinkFlagsButtonClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Create View And Link Flags Button Clicked', attributes);
}

/****************************************
 * Link flags modal
 ****************************************/

export function trackLinkResourceUpdated(attributes?: AnalyticEventData) {
  trackViewEvent('Link Resource Updated', attributes);
}

/****************************************
 * View list ellipsis menu options
 ****************************************/

export function trackEditViewMenuItemClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Edit View Menu Item Clicked', attributes);
}

export function trackLinkFlagsMenuItemClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Link Flags Menu Item Clicked', attributes);
}

export function trackLinkResourcesMenuItemClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Link Resources Menu Item Clicked', attributes);
}

export function trackDeleteViewMenuItemClicked(attributes?: AnalyticEventData) {
  trackViewEvent('Delete View Menu Item Clicked', attributes);
}

/****************************************
 * Flag dashboard
 ****************************************/

export function trackViewFilterApplied(attributes?: AnalyticEventData) {
  trackViewEvent('View Filter Applied', attributes);
}

export function trackViewFilterExpandCollapseClicked(attributes?: AnalyticEventData) {
  trackViewEvent('View Filter Expand/Collapse Clicked', attributes);
}

/****************************************
 * Flag details
 ****************************************/

export function trackFlagViewsEdited(attributes?: AnalyticEventData) {
  trackViewEvent('Flag Views Edited', attributes);
}

/****************************************
 * Payload filters
 ****************************************/

export const trackPayloadActiveBadgeClicked = () => trackViewEvent('View Payload Active Badge Clicked');
export const trackPayloadActiveBadgeManageKeysClicked = () =>
  trackViewEvent('View Payload Active Badge Manage Keys Clicked');
